module.exports = __webpack_public_path__ + "img/icon-progress-green.39a8829b.png";